// UserProfilePost.js
import { connect } from 'react-redux';
import { goBack } from 'redux-first-history';

import ProfilePost from '../component/ProfilePost.jsx';

import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getMeData from '../selector/getMeData.js';
import getListData from '../selector/getListData.js';
import getNetworkingData from '../selector/getNetworkingData.js';
import getFeedName from '../selector/getFeedName.js';
import { getSelectedQueryOptionObject } from '../selector/getFeedQueryObject.js';
import getSelectedFeedQueryOptions from '../selector/getSelectedFeedQueryOptions.js';
import getProfileFeedUnixTimestamp from '../selector/getProfileFeedUnixTimestamp.js';

import setMessageHeightInFeed from '../action/setMessageHeightInFeed.js';
import fetchFeeds, { getReturnType } from '../action/fetchFeeds.js';

import { PROFILE_FEED_REMOTE_CONFIG_KEY_MAP } from '../resource/profileConstants.js';
import { getSortedQueries } from '../resource/feedUtils.js';
import { QueryPrefix, QueryType } from '../resource/feedConstants.js';
import { USER_PROFILE_STORY_LAYOUT } from '../RemoteConfigKeys.js';

const mapStateToProps = (state, { userId, listType }) => {
  const feedNameRemoteConfigKey = PROFILE_FEED_REMOTE_CONFIG_KEY_MAP[listType];
  const outboxFeedName = getFeedName(
    state,
    feedNameRemoteConfigKey,
    '{USER_ID}',
    userId
  );
  const { feedNameWithQuery, intersectedFeedName, filters, sorts } =
    getSelectedQueryOptionObject(
      state,
      outboxFeedName,
      getSelectedFeedQueryOptions(state, feedNameRemoteConfigKey, undefined),
      getRemoteConfigData(
        state,
        `${feedNameRemoteConfigKey}_${QueryPrefix[QueryType.SORT]}`
      )?.[0]
    );
  const listSelectPath = [
    'home',
    getReturnType({ feedName: intersectedFeedName }),
    intersectedFeedName,
  ];
  if (filters.length || sorts.length) {
    listSelectPath.push(
      getSortedQueries({
        filters,
        sorts,
      }).join('&')
    );
  }
  const meId = getMeData(state, 'id');
  const nextPage = getListData(state, listSelectPath, 'nextPage');
  const { intersectedFeedName: pinFeedAlias } = getSelectedQueryOptionObject(
    state,
    outboxFeedName
  );
  const pinnedItemIds = getListData(
    state,
    ['home', getReturnType({ feedName: pinFeedAlias }), pinFeedAlias, 'pinned'],
    'itemIds'
  );
  const postIds = getListData(state, listSelectPath, 'itemIds');
  const isFirstPageFetched = getNetworkingData(
    state,
    [...listSelectPath, 1],
    'isFetched'
  );
  const isFirstPageFetching = getNetworkingData(
    state,
    [...listSelectPath, 1],
    'isFetching'
  );
  const isNextPageFetching = getNetworkingData(
    state,
    [...listSelectPath, nextPage],
    'isFetching'
  );
  const userProfileStoryLayout = getRemoteConfigData(
    state,
    USER_PROFILE_STORY_LAYOUT
  );
  return {
    meId,
    outboxFeedName,
    feedNameWithQuery,
    intersectedFeedName,
    feedNameRemoteConfigKey,
    nextPage,
    profileFeedUnixTimestamp: getProfileFeedUnixTimestamp(
      state,
      userId,
      listType
    ),
    isFirstPageFetched,
    isFirstPageFetching,
    isNextPageFetching,
    pinnedItemIds,
    postIds,
    filters,
    sorts,
    userProfileStoryLayout,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    goBack: () => dispatch(goBack()),
    fetchFeeds: payload => dispatch(fetchFeeds(payload)),
    setMessageHeightInFeed: ({ feedName, messageObject }) =>
      dispatch(
        setMessageHeightInFeed({
          feedName,
          messageObject,
        })
      ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProfilePost);
